export default "__VITE_ASSET__imiC5Img__"